import type { NavSectionProps } from 'src/components/nav-section';

import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

import { Image } from 'src/components/image';
import { Iconify } from 'src/components/iconify';
import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) =>
  name.startsWith('ic-variance') ? (
    <Image src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
  ) : (
    <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
  );

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
  all: icon('ic-all'),
  mine: icon('ic-mine'),
  unassigned: icon('ic-unassigned'),
  myTeams: icon('mdi--account-multiple'),
  whatsappbusiness: icon('ic-variance-whatsapp-business'),
  email: icon('ic-variance-mail'),
  voice: icon('ic-variance-voice'),
  livechat: icon('ic-variance-livechat'),
  setting: icon('ic-settings'),
  campaign: icon('ic-campaign'),
  account: icon('ic-account'),
  channel: icon('ic-channel'),
  tenant: icon('mdi--account-multiple'),
  ticket: icon('mdi--ticket-confirmation-outline'),
  report: icon('ic-report'),
  instagram: icon('ic-variance-instagram'),
  sms: icon('ic-variance-sms'),
  line: icon('ic-variance-line'),
  messenger: icon('ic-variance-facebook'),
  automation: icon('ic-kanban'),
  integrations: icon('ic-parameter'),
  task: <Iconify icon="solar:clipboard-check-bold" />,
};

// ----------------------------------------------------------------------

export const navData: NavSectionProps['data'] = [
  /**
   * Overview
   */
  // {
  //   subheader: 'Overview',
  //   items: [
  //     {
  //       title: 'One',
  //       path: paths.dashboard.root,
  //       icon: ICONS.dashboard,
  //       info: <Label>v{CONFIG.appVersion}</Label>,
  //     },
  //     { title: 'Two', path: paths.dashboard.two, icon: ICONS.ecommerce },
  //     { title: 'Three', path: paths.dashboard.three, icon: ICONS.analytics },
  //   ],
  // },
  /**
   * Management
   */
  {
    // subheader: 'CRM',
    items: [
      {
        title: 'Dashboard',
        path: paths.dashboard.root,
        icon: ICONS.dashboard,
        id: 'dashboard',
        // children: [
        //   { title: 'List', path: paths.account.list },
        //   { title: 'Details', path: paths.account.demo.details },
        // ],
      },
      {
        title: 'Accounts',
        path: paths.account.root,
        icon: ICONS.account,
        id: 'company',
        // children: [
        //   { title: 'List', path: paths.account.list },
        //   { title: 'Details', path: paths.account.demo.details },
        // ],
      },
      {
        title: 'Contacts',
        path: paths.contact.root,
        icon: ICONS.user,
        id: 'contact',
        // children: [
        //   { title: 'List', path: paths.contact.list },
        //   { title: 'Details', path: paths.contact.demo.details },
        // ],
      },

      // {
      //   title: 'Form',
      //   path: paths.form.root,
      //   icon: ICONS.invoice,
      // },
      {
        title: 'Inbox',
        path: paths.chat.root,
        icon: ICONS.chat,
        id: 'inbox',
      },
      {
        title: 'Campaign',
        path: paths.campaign.root,
        icon: ICONS.campaign,
        id: 'campaign',
      },
      // {
      //   title: 'Dialer Campaign',
      //   path: paths.dialerCampaign.root,
      //   icon: ICONS.campaign,
      //   id: 'campaign',
      // },
      {
        title: 'Channel',
        path: paths.channel.root,
        icon: ICONS.channel,
        id: 'channel',
      },
      {
        title: 'Integrations',
        path: paths.integrations.root,
        icon: ICONS.integrations,
        id: 'integrations',
      },
      {
        title: 'Tickets',
        path: paths.ticket.root,
        icon: ICONS.ticket,
        id: 'ticket',
      },
      {
        title: 'Tasks',
        path: paths.task.root,
        icon: ICONS.task,
        id: 'task',
      },
      // {
      //   title: 'lineTemplate',
      //   path: paths.linetemplate.root,
      //   icon: ICONS.ticket,
      //   id: 'linetemplate',
      // },
      {
        title: 'Report',
        path: paths.report.root,
        icon: ICONS.report,
        id: 'report',
        children: [
          { title: 'call_logs', path: paths.report['call-logs'], id: 'callreport' },
          {
            title: 'message_report',
            path: paths.report['message-report'],
            id: 'messagereport',
          },
          {
            title: 'conversation_report',
            path: paths.report['conversation-report'],
            id: 'conversationreport',
          },
          {
            title: 'sms_report',
            path: paths.report['sms-report'],
            id: ['conversation', 'smsreport', 'messagereport', 'sms_report', 'sms'],
          },
          // { title: 'support_report', path: paths.report['support-report'], id: 'ticket' },
        ],
      },
      {
        title: 'csat_report',
        path: paths.csat.root,
        icon: ICONS.analytics,
        id: ['csat_analytics', 'csat_config'],
        children: [
          { title: 'csat_analytics', path: paths.csat.root, id: 'csat_analytics' },
          { title: 'csat_config', path: paths.csat.config, id: 'csat_config' },
        ],
      },
      {
        title: 'Setting',
        path: paths.setting.root,
        icon: ICONS.setting,
        id: 'setting',
        children: [
          { title: 'Organization', path: paths.setting.organization, id: 'organization' },
          { title: 'Users', path: paths.setting.user.root, id: 'user' },
          { title: 'Teams', path: paths.setting.teams.root, id: 'team' },
          { title: 'custom_labels', path: paths.setting['custom-labels'], id: 'label' },
          // { title: 'Template', path: paths.setting.template, id: 'template' },
          {
            title: 'whatsapp_templates',
            path: paths.setting['whatsapp-template'].root,
            id: 'template',
          },
          {
            title: 'whatsapp_templates_add',
            path: paths.setting['whatsapp-template'].add,
            id: 'template_add',
          },
          { title: 'billing', path: paths.setting['billing'].root, id: ['bill', 'billing'] },
          {
            title: 'Webhook',
            path: paths.setting.webhook,
            id: 'webhook',
          },
          // {
          //   title: 'discount',
          //   path: paths.setting.discount,
          //   id: 'discount',
          // },
          // {
          //   title: 'lineTemplate',
          //   path: paths.setting.lineTemplate.root,
          //   id: 'linetemplate',
          //   // children: [
          //   //   // { title: 'richTemplate', path: paths.setting.lineTemplate.root, id: 'richtemplate' },
          //   //   // { title: 'cardbasedTemplate', path: paths.setting.cardTemplate.root, id: 'cardtemplate' },
          //   // ],
          // },
          { title: 'Custom_Fields', path: paths.setting['custom-fields'], id: 'custom-fields' },
          { title: 'discount', path: paths.setting.discount, id: 'discount' },
          { title: 'Snippets', path: paths.setting.snippets, id: 'snippet' },
          // { title: 'lifeCycle', path: paths.setting.lifecycle, id: 'lifecycle' },
          { title: 'audit_logs', path: paths.setting.auditLog.root, id: 'audit_log' },
          // {
          //   title: 'channel_feature_flags',
          //   path: paths.setting.channelFeatureFlags,
          //   id: 'channel',
          // },
          { title: 'ai_settings', path: paths.setting['ai-settings'], id: 'ai_settings' },
          { title: 'ai_usage_billing', path: paths.setting.aiUsage, id: 'ai_usage' },
          {
            title: 'auto_assign_routing',
            path: paths.setting.autoAssignRouting,
            id: 'auto_assign',
          },
          {
            title: 'SLA_POLICIES',
            path: paths.setting.slaPolicy,
            id: 'sla_policy',
          },
          // { title: 'Chatbots', path: paths.setting.chatbots.root, id: 'chatbot' },
          // { title: 'Voicebots', path: paths.setting.voicebots.root, id: 'voicebot' },
          { title: 'Calendar', path: paths.setting.calendar.root, id: 'calendar' },
          { title: 'Task Statuses', path: paths.setting['task-statuses'], id: 'task' },
          { title: 'ACCESS_CONTROL', path: paths.setting.permissions, id: 'roles' },
          // { title: 'did_manage', path: paths.setting['did-manage'], id: 'call' },
          // { title: 'User Profie', path: paths.setting.root },
          // { title: 'Addons', path: paths.setting.root },
          // { title: 'Invoices', path: paths.setting.root },
        ],
      },
      {
        title: 'Automation',
        path: paths.automation.root,
        icon: ICONS.automation,
        id: ['workflow', 'ai_agents', 'ai_analytics'],
        children: [
          { title: 'Workflows', path: paths.automation.workflows.root, id: 'workflow' },
          { title: 'ai_agents', path: paths.automation.agents.root, id: 'ai_agents' },
          { title: 'ai_analytics', path: paths.automation.agents.analytics, id: 'ai_analytics' },
          // { title: 'Learning Queue', path: paths.automation.agents.learningQueue, id: 'contact' },
          // { title: 'Knowledge Gaps', path: paths.automation.agents.knowledgeGaps, id: 'contact' },
        ],
      },
      {
        title: 'Tenants',
        path: paths.tenant.root,
        icon: ICONS.tenant,
        id: 'tenants',
      },
      {
        title: 'SMS Overview',
        path: paths.tenant.smsOverview,
        icon: ICONS.sms,
        id: 'tenants',
      },
      {
        title: 'Subscription Overview',
        path: paths.tenant.subscriptionOverview,
        icon: ICONS.invoice,
        id: 'tenants',
      },
      {
        title: 'Tenant Reports',
        path: paths.tenant.reports,
        icon: ICONS.analytics,
        id: 'tenants',
      },
    ],
  },
];

// ------------------------------------------------------------------

export const chatPannelData: NavSectionProps['data'] = [
  {
    subheader: 'Inbox',
    items: [
      {
        title: 'All',
        path: paths.chat.all,
        icon: ICONS.all,
      },
      {
        title: 'Mine',
        path: paths.chat.mine,
        icon: ICONS.mine,
      },
      {
        title: 'Unassigned',
        path: paths.chat.unassigned,
        icon: ICONS.unassigned,
      },
      {
        // Tab value is the lowercased title: 'my teams' (MY_TEAMS_PATH in chat/utils/inbox-tabs)
        title: 'My Teams',
        path: '',
        icon: ICONS.myTeams,
      },
    ],
  },
  {
    subheader: 'Channels',
    items: [
      {
        title: 'VARIANCE_WHATSAPP_BUSINESS',
        path: paths.chat.whatsapp,
        icon: ICONS.whatsappbusiness,
        type: 'WHATSAPP',
      },
      {
        title: 'VARIANCE_EMAIL',
        path: paths.chat.email,
        icon: ICONS.email,
        type: 'EMAIL',
      },
      {
        title: 'VARIANCE_VOICE',
        path: paths.chat.voice,
        icon: ICONS.voice,
        type: 'VOICE',
      },
      {
        title: 'VARIANCE_LIVE_CHAT',
        path: paths.chat['live-chat'],
        icon: ICONS.livechat,
        type: 'LIVE_CHAT',
      },
      {
        title: 'VARIANCE_INSTAGRAM',
        path: paths.chat.instagram,
        icon: ICONS.instagram,
        type: 'INSTAGRAM',
      },
      {
        title: 'VARIANCE_MESSENGER',
        path: paths.chat.messenger,
        icon: ICONS.messenger,
        type: 'MESSENGER',
      },
      // {
      //   title: 'VARIANCE_LINE',
      //   path: paths.chat.line,
      //   icon: ICONS.line,
      //   type: 'LINE',
      // },
      {
        title: 'VARIANCE_SMS',
        path: paths.chat.sms,
        icon: ICONS.sms,
        type: 'SMS',
      },
      // {
      //   title: 'TELEGRAM',
      //   path: paths.chat.telegram,
      //   icon: ICONS.telegram,
      //   type: 'TELEGRAM',
      // },
      // {
      //   title: 'VARIANCE_TEAMS',
      //   path: paths.chat.teams,
      //   icon: ICONS.teams,
      //   type: 'MICROSOFTTEAMS',
      // },
    ],
  },
];
